import { Component, OnInit } from '@angular/core';
import { NetzTranslateService } from '../services/netz-translate.service';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ResetPasswordService } from './reset-password.service';
import { ResetPasswordModel } from './reset-password.models';
import { DestroyableComponent } from '../common/destroyable.component';
import { ErrorService } from '../services/error/error.service';

interface TokenData {
  email: string;
}

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  providers: [ResetPasswordService],
})
export class ResetPasswordComponent extends DestroyableComponent implements OnInit {
  showPasswordTwo: boolean;
  showPasswordThree: boolean;
  languageOptions: string[] = [];
  errors: string[];

  form: FormGroup;
  formDefaultValue: any;

  constructor(
    public netzTranslateService: NetzTranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private resetPasswordService: ResetPasswordService,
    private errorService: ErrorService
  ) {
    super();
  }

  ngOnInit(): void {
    const token = this.route.snapshot.params.token as string;
    let tokenData: TokenData;
    try {
      tokenData = this.extractTokenData(token);
    } catch {
      this.errorService.showError('Invalid reset password token');
      this.goToHome();
    }
    this.form = new FormGroup(
      {
        email: new FormControl(tokenData.email, [Validators.required]),
        password: new FormControl(null, [Validators.required]),
        repeatPassword: new FormControl(null, [Validators.required]),
        token: new FormControl(token, [Validators.required]),
      },
      [this.validateForm()]
    );
    this.formDefaultValue = { ...this.form.value };
    this.languageOptions = this.netzTranslateService.getLangs();

    this.preventLeak(this.form.valueChanges).subscribe(_ => (this.errors = []));
  }

  save() {
    const formValue = this.form.value;
    const requestModel: ResetPasswordModel = {
      password: formValue.password,
      repeatPassword: formValue.repeatPassword,
      token: formValue.token,
    };
    this.preventLeak(this.resetPasswordService.resetPassword(requestModel)).subscribe(
      _ => {
        this.goToHome();
      },
      err => {
        const error = err.error as string;

        if (error === 'invalid_token') {
          this.errors = ['reset-password.invalid-token-error'];
          return;
        }

        if (error === 'passwords_not_match') {
          this.errors = ['reset-password.passwords-not-match-error'];
          return;
        }

        const errors = (err.error as string).split('|');
        this.errors = errors;
      }
    );
  }

  private goToHome() {
    this.router.navigate(['/dashboard']);
  }

  cancel() {
    this.form.reset(this.formDefaultValue);
  }

  selectLanguage(lang: string) {
    this.netzTranslateService.useLanguage(lang);
  }

  showTerms(): void {}

  validateForm() {
    return (control: FormGroup): ValidationErrors | null => {
      const { value } = control;

      if (value.password === value.repeatPassword) {
        return null;
      }

      return {
        ['invalid']: "Password repeat check doesn't match",
      };
    };
  }

  private extractTokenData(token: string): TokenData {
    const tokenDataPart = token.substring(token.indexOf('.') + 1, token.lastIndexOf('.'));
    const tokenDataPartJson = atob(tokenDataPart);
    const tokenData: { payload: string } = JSON.parse(tokenDataPartJson);
    const payload: TokenData = JSON.parse(tokenData.payload);

    return payload;
  }
}
